<template lang="pug">
  .profile-page__main
    .profile-page__body
      section.profile-page-form__section.profile-section
        .profile-section__title
          h2.profile-section-title Общая информация
        .profile-section__body
          .form
            .form__elem
              .form-elem.form-elem_horizontal(
              :class="{'form-elem_error':fieldsErrors.campName.value}"
              )
                .form-elem__title Лагерь
                .form-elem__body
                  simple-select-form(
                  :list-data="campsNames"
                  :default-value="fields.campName"
                  @onChangeDefaultValue="changeCampName"
                  :type="'campName'"
                  :specificChoice="true"
                  )
            .form__elem
              .form-elem.form-elem_horizontal(
                :class="{'form-elem_error':fieldsErrors.name.value}"
              )
                .form-elem__title Название
                .form-elem__body
                  input.input.input_full(
                  maxlength="128"
                  v-model="fields.name"
                  @input="resetError('name')"
                  )
            .form__elem
              .form-elem.form-elem_horizontal(
              :class="{'form-elem_error': datesError}"
              )
                .form-elem__title Даты проведения
                .form-elem__body
                  .double-input
                    date-picker(
                    placeholder="дд.мм.гггг"
                    v-model="fields.dateStart"
                    format="DD.MM.YYYY"
                    lang="ru"
                    input-class="input input_full"
                    :clearable="false"
                    :editable="true"
                    @change="resetError('emptyDates,wrongDates,crossDates')"
                    )
                    span.double-input__separator -
                    date-picker(
                    placeholder="дд.мм.гггг"
                    v-model="fields.dateFinish"
                    format="DD.MM.YYYY"
                    lang="ru"
                    input-class="input input_full"
                    :clearable="false"
                    :editable="true"
                    @change="resetError('emptyDates,wrongDates,crossDates')"
                    )
            .form__elem.form__elem_short
              .form-elem.form-elem_horizontal(
              :class="{'form-elem_error':fieldsErrors.capacity.value}"
              )
                .form-elem__title Количество человек
                .form-elem__body
                  input.input.input_full(
                  maxlength="128"
                  v-model="fields.capacity"
                  @input="resetError('capacity')"
                  ref="capacity"
                  )
            .form__elem
              .form-elem.form-elem_horizontal(
              :class="{'form-elem_error':fieldsErrors.emptyPrice.value || fieldsErrors.wrongPrice.value}"
              )
                .form-elem__title Базовая цена за смену
                .form-elem__body
                  .double-input
                    input.input.input_full(
                    maxlength="128"
                    v-model="fields.priceFrom"
                    @input="resetError('emptyPrice,wrongPrice')"
                    ref="priceFrom"
                    )
                    span.double-input__separator -
                    input.input.input_full(
                    maxlength="128"
                    v-model="fields.priceTo"
                    @input="resetError('emptyPrice,wrongPrice')"
                    ref="priceTo"
                    )
            .form__elem
              .form-elem.form-elem_horizontal(
              :class="{'form-elem_error': ageError}"
              )
                .form-elem__title Возраст участников
                .form-elem__body
                  .double-input
                    input.input.input_full(
                    maxlength="128"
                    v-model="fields.ageFrom"
                    @input="resetError('emptyAge,minAge,maxAge,wrongAge')"
                    ref="ageFrom"
                    )
                    span.double-input__separator -
                    input.input.input_full(
                    maxlength="128"
                    v-model="fields.ageTo"
                    @input="resetError('emptyAge,minAge,maxAge,wrongAge')"
                    ref="ageTo"
                    )
            .form__elem
              .form-elem.form-elem_horizontal(
              :class="{'form-elem_error': dateOrdersError}"
              )
                .form-elem__title Сроки подачи заявок
                .form-elem__body
                  .double-input
                    date-picker(
                    placeholder="дд.мм.гггг"
                    v-model="fields.dateStartOrders"
                    format="DD.MM.YYYY"
                    lang="ru"
                    input-class="input input_full"
                    :clearable="false"
                    :editable="true"
                    @change="resetError('emptyDateOrders,wrongDateOrders,crossDates')"
                    )
                    span.double-input__separator -
                    date-picker(
                    placeholder="дд.мм.гггг"
                    v-model="fields.dateFinishOrders"
                    format="DD.MM.YYYY"
                    lang="ru"
                    input-class="input input_full"
                    :clearable="false"
                    :editable="true"
                    @change="resetError('emptyDateOrders,wrongDateOrders,crossDates')"
                    )
      section.profile-page-form__section.profile-section
        .profile-section__title
          h2.profile-section-title Фотографии
        .profile-section__body
          .form
          .form__elem.form__elem_full
            upload-photo-2(
            :photos="fields.photos"
            @on-change="onChangeShitPhotos"
            )
      section.profile-page-form__section.profile-section
        .profile-section__body
          .form
            .form__elem.form__elem_button
              .form-elem
                .form-elem__body
                  button.button.button_paint-main.button_long(
                  @click.prevent="onSaveCamp()"
                  )
                    .button__text Сохранить
                .form-elem__error(
                  v-if="currentErrorMessage.length > 0"
                ) {{currentErrorMessage}}
</template>

<script>

import DatePicker from "vue2-datepicker";
import {mapState} from "vuex";
import UploadPhoto2 from "../../../../../components/uploadPhoto2/UploadPhoto2";
import SimpleSelectForm from "../../../../../components/simpleSelectForm/SimpleSelectForm";
import Inputmask from "inputmask";
export default {
  name: "ManagerShiftEditorGeneral",
  components: {
    SimpleSelectForm,
    UploadPhoto2,
    DatePicker,
    Inputmask
  },
  props: {
    shiftData: {
      type: Object,
      default: () => ({})
    }
  },
  computed: {
    ...mapState(["userData"]),
    campsNames() {
      let arr = [
        {
          text: "Выберите лагерь",
          value: null
        }
      ];
      if (this.userData && this.userData.camps) {
        arr = this.userData.camps.map(item => {
          return {
            text: item.name,
            value: item.id
          };
        });
      }
      return arr;
    },
    datesError() {
      const arr = [
        "emptyDates",
        "wrongDates",
        "crossDates"
      ];
      const index = arr.findIndex(field => {
        return this.fieldsErrors[field].value;
      });
      if (index === -1) {
        return false;
      }
      return true;
    },
    dateOrdersError() {
      const arr = [
        "emptyDateOrders",
        "wrongDateOrders",
        "crossDates"
      ];
      const index = arr.findIndex(field => {
        return this.fieldsErrors[field].value;
      });
      if (index === -1) {
        return false;
      }
      return true;
    },
    ageError() {
      const arr = [
        "emptyAge",
        "minAge",
        "maxAge",
        "wrongAge"

      ];
      const index = arr.findIndex(field => {
        return this.fieldsErrors[field].value;
      });
      if (index === -1) {
        return false;
      }
      return true;
    }
  },
  data() {
    return {
      fields: {
        campName: {
          text: "Выберите лагерь",
          value: null
        },
        name: "",
        dateStart: "",
        dateFinish: "",
        capacity: "",
        priceFrom: "",
        priceTo: "",
        ageFrom: "",
        ageTo: "",
        dateStartOrders: "",
        dateFinishOrders: "",
        photos: []
      },
      fieldsErrors: {
        campName: {
          value: false,
          message: "Выберите лагерь"
        },
        name: {
          value: false,
          message: "Введите название смены"
        },
        emptyDates: {
          value: false,
          message: "Введите даты проведения"
        },
        wrongDates: {
          value: false,
          message: "Неправильный диапазон дат проведения"
        },
        capacity: {
          value: false,
          message: "Введите вместимость"
        },
        emptyPrice: {
          value: false,
          message: "Введите стоимость"
        },
        wrongPrice: {
          value: false,
          message: "Неправильный диапазон цен"
        },
        emptyAge: {
          value: false,
          message: "Введите возраст участников"
        },
        minAge: {
          value: false,
          message: "Минимальный возраст должен быть не менее 7 лет"
        },
        maxAge: {
          value: false,
          message: "Максимальный возраст должен быть не более 17 лет"
        },
        wrongAge: {
          value: false,
          message: "Неправильный диапазон возрастов участников"
        },
        emptyDateOrders: {
          value: false,
          message: "Введите сроки подачи заявок"
        },
        wrongDateOrders: {
          value: false,
          message: "Неправильный диапазон сроков подачи заявок"
        },
        crossDates: {
          value: false,
          message: "Пересечение даты начала смены с датой окончания подачи оригиналов или подачи заявок"
        }
      },
      currentErrorMessage: "",
      capacityMask: new Inputmask("integer", {
        placeholder: "",
        allowMinus: false,
        rightAlign: false,
        max: 32000
      }),
      priceMask: new Inputmask("decimal", {
        placeholder: "",
        allowMinus: false,
        rightAlign: false,
        digits: 2
      }),
      ageMask: new Inputmask("integer", {
        placeholder: "",
        allowMinus: false,
        rightAlign: false
      })
    };
  },
  methods: {
    changeCampName(data, type) {
      this.fields[type] = data;
      this.resetError("campName");
    },
    setFields() {
      this.fields.campName = {
        text: this.shiftData.camp.name,
        value: this.shiftData.camp.id
      },
      this.fields.name = this.shiftData.name;
      this.fields.dateStart = this.shiftData.date_started;
      this.fields.dateFinish = this.shiftData.date_finished;
      this.fields.capacity = this.shiftData.capacity;
      this.fields.priceFrom = this.shiftData.price_from;
      this.fields.priceTo = this.shiftData.price_to;
      this.fields.ageFrom = this.shiftData.age_from;
      this.fields.ageTo = this.shiftData.age_to;
      this.fields.dateStartOrders = this.shiftData.date_start_orders;
      this.fields.dateFinishOrders = this.shiftData.date_finish_orders;
      this.fields.photos = this.shiftData.photos;
    },
    transformDate(date) {
      const d = new Date(date);
      const _date = `${d.getFullYear()}-${("0" + (d.getMonth() + 1)).slice(
        -2
      )}-${("0" + d.getDate()).slice(-2)}`;
      return _date;
    },
    onChangeShitPhotos(photos) {
      this.fields.photos = photos;
    },

    validation() {
      const errors = [];

      if (!this.fields.campName.value) {
        errors.push("campName");
      }
      if (this.fields.name.length === 0) {
        errors.push("name");
      }
      if (!this.fields.dateStart || !this.fields.dateFinish) {
        errors.push("emptyDates");
      } else if (new Date(this.fields.dateStart) > new Date(this.fields.dateFinish)) {
        errors.push("wrongDates");
      }
      if (this.fields.capacity.length === 0) {
        errors.push("capacity");
      }
      if (!this.fields.priceFrom || !this.fields.priceTo) {
        errors.push("emptyPrice");
      } else if (Number(this.fields.priceFrom) > Number(this.fields.priceTo)) {
        errors.push("wrongPrice");
      }
      if (!this.fields.ageFrom || !this.fields.ageTo) {
        errors.push("emptyAge");
      } else if (Number(this.fields.ageFrom) < 7) {
        errors.push("minAge");
      } else if (Number(this.fields.ageTo) > 17) {
        errors.push("maxAge");
      } else if (Number(this.fields.ageFrom) > Number(this.fields.ageTo)) {
        errors.push("wrongAge");
      }
      if (!this.fields.dateStartOrders || !this.fields.dateFinishOrders) {
        errors.push("emptyDateOrders");
      } else if (new Date(this.fields.dateStartOrders) > new Date(this.fields.dateFinishOrders)) {
        errors.push("wrongDateOrders");
      }

      if (this.fields.dateStart && this.fields.dateFinishOrders) {
        if (new Date(this.fields.dateStart) < new Date(this.fields.dateFinishOrders)) {
          errors.push("crossDates");
        }
      }

      if (errors.length > 0) {
        errors.forEach(err => {
          this.fieldsErrors[err].value = true;
        });
        this.currentErrorMessage = this.fieldsErrors[errors[0]].message;
        return false;
      }
      return true;
    },

    onSaveCamp() {
      if (!this.validation()) {
        return;
      };
      const data = {
        camp: this.fields.campName.value,
        name: this.fields.name,
        date_started: this.transformDate(this.fields.dateStart),
        date_finished: this.transformDate(this.fields.dateFinish),
        capacity: this.fields.capacity,
        price_from: this.fields.priceFrom,
        price_to: this.fields.priceTo,
        show_price: true,
        age_from: this.fields.ageFrom,
        age_to: this.fields.ageTo,
        date_start_orders: this.transformDate(this.fields.dateStartOrders),
        date_finish_orders: this.transformDate(this.fields.dateFinishOrders),
        photos: this.fields.photos.map(item => {
          return item.id;
        })
      };
      this.$emit("on-save-shift", data);
    },
    resetError(field) {
      const arr = field.split(",");
      arr.forEach(item => {
        this.fieldsErrors[item].value = false;
      });

      this.currentErrorMessage = "";
    }
  },
  watch: {
    shiftData(val) {
      this.setFields(val);
    }
  },
  mounted() {
    this.capacityMask.mask(this.$refs.capacity);
    this.priceMask.mask(this.$refs.priceFrom);
    this.priceMask.mask(this.$refs.priceTo);
    this.ageMask.mask(this.$refs.ageFrom);
    this.ageMask.mask(this.$refs.ageTo);
    if (this.shiftData) {
      this.setFields(this.shiftData);
    }
  }
};
</script>
